// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../types";

import gql from "graphql-tag";
export type SuppliersSupplierDealFragment = {
  __typename?: "SupplierDeal";
  ID: number;
  message?: string | null;
  cost?: number | null;
  currency: string;
  supplier: {
    __typename?: "Supplier";
    ID: number;
    name: string;
    type: Types.SupplierType;
  };
  attachments?: Array<{
    __typename?: "SupplierDealAttachment";
    ID: number;
    filename: string;
    URL: string;
  }> | null;
};

export const SuppliersSupplierDealFragmentDoc = gql`
  fragment SuppliersSupplierDeal on SupplierDeal {
    ID
    supplier {
      ID
      name
      type
    }
    message
    cost
    currency
    attachments {
      ID
      filename
      URL
    }
  }
`;
